// extracted by mini-css-extract-plugin
export var filterIncDec = "_am-0";
export var leftBorder = "_am-1";
export var rightBorder = "_am-2";
export var stringInput = "_am-3";